import { countBy } from "lodash";
export class DocumentElementMPNRepository {
    async getMPNCounts(documentId) {
        const records = await this.getElementMPNRecords(documentId);
        return countBy(records, "mpn");
    }
}
//# sourceMappingURL=DocumentElementMPNRepository.js.map